module.exports = __webpack_public_path__ + "static/media/zoom.3dca18d5.svg";